import firebase from "firebase/app";
import "firebase/firestore";

import User from "@/models/User";

const UserModelService = {
  async getUsersByIdsKeyedById(userIds) {
    let users = {};

    let queries = [];
    for (let i = 0; i < userIds.length; i += 10) {
      queries.push(
        firebase
          .firestore()
          .collection("users")
          .withConverter(User.firebaseConverter)
          .where(
            firebase.firestore.FieldPath.documentId(),
            "in",
            userIds.slice(i, i + 10)
          )
      );
    }

    let promises = [];
    queries.forEach(firebaseQuery => {
      promises.push(firebaseQuery.get());
    });

    await Promise.all(promises).then(results => {
      return results.forEach(usersSnapshot => {
        usersSnapshot.forEach(userSnapshot => {
          let user = { id: userSnapshot.id, ...userSnapshot.data() };
          users[user.id] = user;
        });
      });
    });
    return users;
  }
};

export default UserModelService;
